import { cn } from '@shared/lib/utils'

export type NetworkType = 'visa' | 'mastercard' | 'both' | 'amex' | 'discover'

interface NetworkLogoProps {
  network: NetworkType
  className?: string
}

function VisaLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 48 16"
      aria-label="Visa"
      className={cn('h-3 w-auto', className)}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="0"
        y="13"
        fontFamily="Arial, sans-serif"
        fontWeight="700"
        fontStyle="italic"
        fontSize="16"
        fill="#1A1F71"
        letterSpacing="-0.5"
      >
        VISA
      </text>
    </svg>
  )
}

function MastercardLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 20"
      aria-label="Mastercard"
      className={cn('h-4 w-auto', className)}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="10" r="10" fill="#EB001B" />
      <circle cx="20" cy="10" r="10" fill="#F79E1B" />
      <path
        d="M16 3.8a10 10 0 0 1 0 12.4A10 10 0 0 1 16 3.8z"
        fill="#FF5F00"
      />
    </svg>
  )
}

const networkLabels: Record<NetworkType, string> = {
  visa: 'Visa',
  mastercard: 'Mastercard',
  both: 'Visa & Mastercard',
  amex: 'Amex',
  discover: 'Discover',
}

export function NetworkLogo({ network, className }: NetworkLogoProps) {
  const label = networkLabels[network]
  if (!label) return <span className="text-xs text-muted-foreground">{network}</span>

  if (network === 'amex' || network === 'discover') {
    return <span className={cn('text-xs font-medium text-foreground/80', className)}>{label}</span>
  }

  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      {network === 'visa' && <VisaLogo />}
      {network === 'mastercard' && <MastercardLogo />}
      {network === 'both' && (
        <>
          <VisaLogo />
          <MastercardLogo />
        </>
      )}
    </span>
  )
}
